import { n$2, t$2, e$2 } from '@/js/global/global';
import { register } from '@/js/global/shopify-theme-sections'

const anchorSelectors = {
  anchor: "[data-js-anchor]",
  anchorLinks: "a[href^=\"#\"]"
};

register("anchor", {
  events: [],

  onLoad() {
    this.anchor = n$2(anchorSelectors.anchor, this.container);
    this.anchorLinks = t$2(anchorSelectors.anchorLinks, document);

    let matchingAnchorLinks = [];

    // Collect any anchor links where the href (excluding the hash) matches the anchor id
    if (this.anchorLinks.length > 0) {
      matchingAnchorLinks = this.anchorLinks.filter(anchorLink => anchorLink.getAttribute("href").substring(1) === this.anchor.id);
    }

    // For any matching anchor links, add a scrollToAnchor click event
    if (matchingAnchorLinks.length > 0) {
      matchingAnchorLinks.forEach(matchingAnchorLink => {
        this.events.push(e$2(matchingAnchorLink, "click", (e) => {
          this.scrollToAnchor(this.anchor, e);
        }));
      });
    }
  },

  scrollToAnchor(anchorEl, event) {
    event.preventDefault();

    // Get Nav Bar height
    const navBar = document.querySelector('.header__outer-wrapper');

    if (anchorEl !== null) {
      window.scrollTo({
        top: anchorEl.offsetTop - navBar.offsetHeight,
        behavior: "smooth"
      });
    }
  },

  onUnload() {
    this.anchor.destroy();
    this.anchorLinks.destroy();
    this.events.forEach(unsubscribe => unsubscribe());
  }
});
